module.exports = "pegasus/assets/spectrum.png";